<k2-users-selector
  [config]="config"
  [selected]="selected"
  [onlyTeam]="onlyTeam"
  (selectedChange)="update($event)"
></k2-users-selector>
